import { CountryTypeDto, ExperienceCompanyTypeDto } from '@/api/generated';
import { ExperienceCompaniesTranslation } from '@/assets/locales/views/experienceCompanies/experienceCompanies.translation.en.ts';

export const experienceCompaniesTranslation: ExperienceCompaniesTranslation = {
  actions: 'Akcje',
  addButton: 'Dodaj firmę',
  allCountries: 'Wszystkie kraje',
  allTypes: 'Wszystkie typy',
  columns: {
    actions: 'Akcje',
    country: 'Kraj',
    name: 'Nazwa',
    type: 'Typ',
  },
  countries: {
    [CountryTypeDto.Be]: 'Belgia',
    [CountryTypeDto.Pl]: 'Polska',
    [CountryTypeDto.Ro]: 'Rumunia',
    [CountryTypeDto.Sk]: 'Słowacja',
  },
  deleteConfirmation: 'Czy na pewno chcesz usunąć tę firmę doświadczenia?',
  dialog: {
    buttons: {
      cancel: 'Anuluj',
      create: 'Utwórz',
      save: 'Zapisz',
    },
    createTitle: 'Dodaj firmę doświadczenia',
    editTitle: 'Edytuj firmę doświadczenia',
    fields: {
      country: 'Kraj',
      name: 'Nazwa',
      type: 'Typ',
    },
    validation: {
      nameExists: 'Firma o tej nazwie już istnieje.',
      nameRequired: 'Nazwa firmy jest wymagana.',
    },
  },
  filterByCountry: 'Filtruj po kraju',
  filterByType: 'Filtruj po typie',
  noResults: 'Nie znaleziono firm doświadczenia.',
  searchPlaceholder: 'Szukaj po nazwie...',
  types: {
    [ExperienceCompanyTypeDto.Competitor]: 'Konkurent',
    [ExperienceCompanyTypeDto.None]: 'Brak',
    [ExperienceCompanyTypeDto.Orange]: 'Orange',
    [ExperienceCompanyTypeDto.Partner]: 'Partner',
  },
};
